/**
 * Forces a full page reload when the page is restored from the browser's
 * back/forward cache (bfcache) — but only on pages that hold client-side
 * state which can't be safely reconstructed from outside the components
 * that own it (selected variant, quantity, in-flight B2B quantity rules in
 * <product-form-component>; open/closed state in <theme-drawer>; the
 * mirrored button state in <sticky-add-to-cart>).
 *
 * The bfcache restores the entire page exactly as it was at the moment you
 * navigated away — including all of that component-internal state — with
 * no network request and no re-render from the server. A reload forces the
 * same fresh, server-rendered state a normal (non-cached) navigation would
 * already produce.
 *
 * Scoped rather than global: a page with none of these elements (e.g. a
 * plain content page) has nothing stateful to go stale, so it's left to
 * benefit from the instant bfcache restore as normal.
 *
 * event.persisted is true only when the page was served from bfcache; it's
 * false (or the event never fires) on a normal fresh navigation, so this
 * never triggers an extra reload on first page load.
 */
const STATEFUL_SELECTORS = 'product-form-component, theme-drawer, sticky-add-to-cart';

window.addEventListener('pageshow', (event) => {
  if (event.persisted && document.querySelector(STATEFUL_SELECTORS)) {
    window.location.reload();
  }
});